import React from 'react';

import Navbar from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import WhyBroker from './components/WhyBroker';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import Solutions from './components/Solutions';
import QuoteRequest from './components/QuoteRequest';
import Faq from './components/Faq';

// Index of the whole website
function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <WhyBroker />
      <Solutions />
      <QuoteRequest />
      <ContactUs/>
      <Faq/>
      <Footer />
    </div>
  );
}

export default App;
